import React from 'react';
import { injectIntl } from 'react-intl';
import translate from '../../../lib/utils/translate';

var AmountItemHeader = function AmountItemHeader(_ref) {
  var title = _ref.title,
      type = _ref.type,
      currency = _ref.currency,
      displayLimit = _ref.displayLimit,
      intl = _ref.intl;
  return React.createElement(
    'div',
    { className: 'responsiblegaming-item-header' },
    React.createElement(
      'div',
      { className: 'title-text' },
      title,
      displayLimit && type !== 'LoginTime' && React.createElement(
        'span',
        { className: 'info-amount' },
        displayLimit.RemainingAmount,
        '/',
        displayLimit.Amount,
        ' ',
        currency
      ),
      displayLimit && type === 'LoginTime' && React.createElement(
        'span',
        { className: 'info-amount' },
        displayLimit.RemainingAmount,
        '/',
        displayLimit.Amount,
        ' ',
        translate({
          id: 'label.hours-short',
          defaultMessage: 'h'
        }, intl)
      )
    )
  );
};

export default injectIntl(AmountItemHeader);